export type Plan = {
  _id: string;
  id: "starter" | "pro";
  name: string;
  img: string;
  items: string[];
  price: { USD: number; INR: number; EURO: number }; // monthly price in USD
  billing: "per user / mo";
  tagline: string;
  isPopular?: boolean; // show "Popular Choice" badge
  isCurrent?: boolean; // show "Current Plan"
  cta: string; // button label
  tokens: number;
};

export const PLANS: Plan[] = [
  {
    _id: "68cbd8deb7e14faaec25edfb",
    id: "starter",
    name: "Starter",
    img: "https://assets.passionbits.io/public/client-dashboard/images/starter.webp",
    items: [
      "<span class='font-semibold text-gray-900 text-[0.95rem]'>20</span> tokens",
      "Track up to <span class='font-semibold text-gray-900 text-[0.95rem]'>5</span> products <span class='text-gray-500'>(1 credit / product)</span>",
      "<span class='font-semibold text-gray-900 text-[0.95rem]'>5</span> competitors per product",
      "Ad Library access",
      "Reddit thread monitoring",
      "Script recommendations",
      "<span class='font-semibold text-gray-900 text-[0.95rem]'>1</span> user seat",
      "Email or Slack notifications",
      "Data refresh every <span class='font-semibold text-gray-900 text-[0.95rem]'>10 days</span>",
      "Historical data: <span class='font-semibold text-gray-900 text-[0.95rem]'>until trial ends</span>",
      "Standard email support",
      "Bookmark up to <span class='font-semibold text-gray-900 text-[0.95rem]'>80 videos</span>",
    ],
    price: {
      USD: 29,
      INR: 2399,
      EURO: 27,
    },
    tagline: "Perfect for freelancers & new brands exploring what’s possible.",
    tokens: 20,
    isPopular: false,
    cta: "Purchase",
    billing: "per user / mo",
  },

  {
    _id: "68cbd8deb7e14faaec25edfc",
    id: "pro",
    name: "Pro",
    img: "https://assets.passionbits.io/public/client-dashboard/images/pro.webp",
    items: [
      "<span class='font-semibold text-gray-900 text-[0.95rem]'>85</span> tokens",
      "Track up to <span class='font-semibold text-gray-900 text-[0.95rem]'>10</span> products <span class='text-gray-500'>(1 credit / product)</span>",
      "<span class='font-semibold text-gray-900 text-[0.95rem]'>10</span> competitors per product",
      "Ad Library access",
      "Reddit thread monitoring",
      "Script recommendations",
      "<span class='font-semibold text-gray-900 text-[0.95rem]'>3 seats</span> <span class='text-gray-500'>(view-only access)</span>",
      "Email or Slack notifications",
      "Data refresh every <span class='font-semibold text-gray-900 text-[0.95rem]'>4 days</span>",
      "Historical data: <span class='font-semibold text-gray-900 text-[0.95rem]'>Unlimited while plan is active</span>",
      "Priority chat & email support",
      "Bookmarking: <span class='font-semibold text-gray-900 text-[0.95rem]'>Unlimited</span>",
    ],
    price: {
      USD: 129,
      INR: 10499,
      EURO: 119,
    },
    tagline: "Built for growing brands & teams that want more scale.",
    tokens: 85,
    billing: "per user / mo",
    isPopular: true,
    cta: "Purchase",
  },
];
